"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsValueMatchMultiplePatterns = void 0;
var getIsValueMatchMultiplePatterns = function (_a) {
    var patterns = _a.patterns, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.allValid, allValid = _c === void 0 ? false : _c;
    return patterns.reduce(function (acc, pattern) {
        if ((acc && !allValid) || (!acc && allValid)) {
            return acc;
        }
        return pattern.test(value);
    }, allValid);
};
exports.getIsValueMatchMultiplePatterns = getIsValueMatchMultiplePatterns;
